export const WITNESS_CONNECTOR_PATH = '/downloads/asenion-witness-mcp.js';
export const WITNESS_SERVER_NAME = 'asenion-witness';
export const GUARDIAN_MCP_PATH = '/guardian/mcp';
export const ONE_COMMAND_SERVER_NAME = 'asenion';

export interface WitnessConnection {
  baseUrl?: string | null;
  projectId?: string | null;
  isActive?: boolean | null;
}

export interface WitnessConnectInput {
  mcpUrl: string;
  exchangeUrl: string;
  orgId: string;
  projectId: string;
  credential: string;
}

// The same rule the server applies: the project's own active connection wins over the org-wide one.
export function witnessMcpUrlOf(
  connections: WitnessConnection[],
  projectId: string
): string | null {
  const active = connections.filter((c) => c.isActive && c.baseUrl);
  const chosen =
    active.find((c) => c.projectId === projectId) ??
    active.find((c) => !c.projectId);
  return chosen?.baseUrl ? `${chosen.baseUrl.replace(/\/+$/, '')}/mcp` : null;
}

export function witnessConnectConfig(input: WitnessConnectInput): string {
  return JSON.stringify(
    {
      mcpServers: {
        [WITNESS_SERVER_NAME]: {
          command: 'node',
          args: ['/path/to/asenion-witness-mcp.js'],
          env: {
            ASENION_URL: input.mcpUrl,
            ASENION_EXCHANGE_URL: input.exchangeUrl,
            ASENION_TENANT_ID: input.orgId,
            ASENION_PROJECT_ID: input.projectId,
            ASENION_CREDENTIAL: input.credential,
          },
        },
      },
    },
    null,
    2
  );
}

export function guardianMcpEndpoint(origin: string): string {
  return `${origin.replace(/\/+$/, '')}${GUARDIAN_MCP_PATH}`;
}

export function claudeCodeAddCommand(
  endpoint: string,
  credential: string
): string {
  return `claude mcp add --transport http ${ONE_COMMAND_SERVER_NAME} ${endpoint} --header "Authorization: Bearer ${credential}"`;
}

export function mcpClientConfig(endpoint: string, credential: string): string {
  return JSON.stringify(
    {
      mcpServers: {
        [ONE_COMMAND_SERVER_NAME]: {
          url: endpoint,
          headers: { Authorization: `Bearer ${credential}` },
        },
      },
    },
    null,
    2
  );
}
